import axios from "axios";
const token = localStorage.getItem("token");
const host = process.env.REACT_APP_API_URL;

export async function fetchDomainsApi() {
  //console.log(host);
  const res = await axios.get(`${host}api/general/domains`, {
    headers: { token: token },
  });
  return res;
}